import Vue from 'vue';
import KEYS from '../../../values/keys';
import { MEETINGS_EVENTS } from '@/content/values/events';
import { MEETINGS_ACTION } from '../../../content/actions/meeting.actions'
import { MeetingService } from '@/services/meeting.service';
import i18n from '../../../content/lang/content.i18n';
import { STORE } from '@/core/store/core.store';
import EdMeetingModal from '@/components/common/ed-meeting-modal/ed-meeting-modal.vue';

export default Vue.component('ed-meeting', { 
  props: ['meeting', 'edition', 'isLoading', 'activeMeeting'],
  components:{
    EdMeetingModal
  },
  data: () => {
    return {
      inProcess: false,
      clicked: false,
    }
  },
  computed: {
    loading(): any {
      return { [KEYS.CSS.EDG_SHIMMER_CONTAINER] : this.isLoading };
    },
    name(): string {
      return this.meeting ? this.meeting.name : '';
    },
    formattedDate(){
      return this.$moment(this.meeting.startingDate);
    },
    active(){
      if(this.meeting && this.activeMeeting == this.meeting.meetingId)
        return { color: 'var(--ed-color-green)' };
      else
        return { };
    }
  },
  methods: {
    goDetail() {
      this.$edEventBus.$emit(MEETINGS_EVENTS.SHOW_MEETING_DETAIL, this.meeting);
    },
    goEditMeeting() {
      this.$edEventBus.$emit(MEETINGS_EVENTS.GO_TO_EDIT_MEETING, this.meeting);
    },
    removeMeeting() {
      this.$EdModal.createConfirmationModal(
        { body: this.started ? this.$i18n.t('meetings.homeMeetings.confirmRemoveMeetingStarted') : this.$i18n.t('meetings.homeMeetings.confirmRemove'), 
        action: () => {
          this.inProcess = true;
          this.$store.dispatch(`${STORE.TEACHER_PORTAL.NAME}/${MEETINGS_ACTION.REMOVE_MEETING}`, this.meeting).catch(() => {
            this.inProcess = false;
          });
        } 
      });
    },
    joinMeeting() {
      this.inProcess = true;
      MeetingService.joinMeeting(this.meeting.meetingId).then(res => {
        this.$EdModal.createModal(EdMeetingModal, res);
      }).catch(() => {
        this.$EdModal.createMessageModal({
          title: i18n.t('meetings.homeMeetings.errorCreatingMeetingTitle'),
          body: i18n.t('meetings.homeMeetings.errorEnteringMeetingBody'),
          type: KEYS.EVENT_TYPES.DANGER
        });
      }).finally(() => {
        this.inProcess = false;
      });
    }
  }
})
